import qs from 'qs'

import request from '@/utils/request'

// 获取用户信息
export const getUserInfo = (data: any) => {
  return request({
    url: `/pc_api/api/pc/getUserInfo`,
    method: 'post',
    data: qs.stringify(data)
  })
}

// 获取课时信息
export const getClassInfo = (data: any) => {
  return request({
    url: `/xbk_api/api/pc/classInfo`,
    method: 'post',
    data: qs.stringify(data)
  })
}

// 获取视频
export const getVideo = () => {
  return request({
    url: `/pc_api/api/pc/about`,
    method: 'post'
  })
}

// 获取即将开始的课程
export const getComingCourse = (data: any) => {
  return request({
    url: `/pc_api/api/pc/comingCourse`,
    method: 'post',
    data: qs.stringify(data)
  })
}

// 课件详情
export const getCourseInfo = (data: any) => {
  return request({
    url: `/pc_api/api/pc/courseDetail`,
    method: 'post',
    data: qs.stringify(data)
  })
}

// 获取最近一次上课记录
export const getLastCourse = (data: any) => {
  return request({
    url: `/pc_api/api/pc/lastCourse`,
    method: 'post',
    data: qs.stringify(data)
  })
}

// 日历接口
export const classTable = () => {
  return request({
    url: `/pc_api/api/pc/classTable`,
    method: 'post'
  })
}

// 获取学生我的课表
export const getStudentLessons = (data: any) => {
  return request({
    url: `/pc_api/api/pc/v1/studentLessons`,
    method: 'post',
    data: qs.stringify(data)
  })
}

// 获取服务端时间
export const getServerTimes = () => {
  return request({
    url: `/pc_api/api/pc/getTimeStamp`,
    method: 'get'
  })
}

// 获取学生我的课表
export const getLessonList = (data: any) => {
  return request({
    url: `/pc_api/api/pc/lessonList`,
    method: 'post',
    data: qs.stringify(data)
  })
}

// 获取设备信息
export const getDeviceInfo = (data: any) => {
  return request({
    url: `/pc_api/api/pc/device/deviceInfo`,
    method: 'post',
    data: qs.stringify(data)
  })
}

// 保存设备信息
export const putDevicesInfo = (data: any) => {
  return request({
    url: `/pc_api/api/pc/device/putDevices`,
    method: 'post',
    data: qs.stringify(data)
  })
}

// 新保存设备信息
export const putDevicesInfo2 = (data: any) => {
  return request({
    url: `/xbk_api/api/deviceCheck`,
    method: 'post',
    data: data,
    headers: {
      // 'Content-Type': 'application/x-www-form-urlencoded',
      userid: localStorage.userid
    }
  })
}

// 校验新老教室
export const inSpareRoomCheck = (data: any) => {
  return request({
    url: `/pc_api/api/pc/inSpareRoomCheck`,
    method: 'post',
    data: qs.stringify(data)
  })
}

// 校验房间内用户
export const verityRoomUser = (data: any) => {
  return request({
    url: `/pc_api/api/pc/channel/user`,
    method: 'post',
    data: qs.stringify(data)
  })
}

// 获取 / 注册  timeid
export const inSpareRoom = (data: any) => {
  return request({
    url: `/pc_api/api/pc/inSpareRoom`,
    method: 'post',
    data: qs.stringify(data)
  })
}

// 进入教室
export const inRoom = (data: any) => {
  return request({
    url: `/pc_api/api/pc/inRoom`,
    method: 'post',
    data: qs.stringify(data)
    // headers: {
    //   deviceId: '',
    //   model: data.browser,
    //   buildVersion: data.buildVersion,
    //   opertaion: data.ver,
    //   platform: 4
    // }
  })
}

// 资金监管 用户点击弹窗上报
export const fundSupervisionPop = (data: any) => {
  return request({
    url: `/xbk_api/api/app/v377/fundSupervisionPop`,
    method: 'post',
    data: qs.stringify(data)
  })
}
